import type { LucideIcon, LucideProps } from 'lucide-react';

export type LucideIconSize = 14 | 16 | 18 | 20 | 24;

export type LucideIconProps = Omit<LucideProps, 'size'> & {
  size?: LucideIconSize;
  icon: LucideIcon;
};

export function _Lucide({ icon: Icon, size = 20, ...other }: LucideIconProps) {
  return <Icon size={size} {...other} />;
}
